// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8c49d","left":"_4e462","right":"_6368d","logo":"d5c34"};